import { useCallback } from 'react';

import { useLocalStorageState } from '@components/component-helpers';

export type LoadingLabel = 'Thinking' | 'Reasoning' | 'Building workflow';

type LoadingState = {
  loadingLabel: LoadingLabel | null;
  isBuilding: boolean;
};

const initialState: LoadingState = {
  loadingLabel: null,
  isBuilding: false,
};

export const useLoadingState = () => {
  const [state, setState] = useLocalStorageState<LoadingState>({
    key: 'ai-builder-loading-state',
    defaultValue: initialState,
  });

  const setThinking = useCallback(() => {
    setState({ loadingLabel: 'Thinking', isBuilding: false });
  }, [setState]);

  const handleLoadingStateEvent = useCallback(
    (label: LoadingLabel) => {
      setState((prev) => {
        return {
          loadingLabel: label,
          isBuilding: label === 'Building workflow' ? true : prev.isBuilding,
        };
      });
    },
    [setState]
  );

  const clearLoadingLabel = useCallback(() => {
    setState((prev) => {
      return { ...prev, loadingLabel: null };
    });
  }, [setState]);

  const setBuilding = useCallback(() => {
    setState((prev) => {
      return { ...prev, isBuilding: true };
    });
  }, [setState]);

  const resetToIdle = useCallback(() => {
    setState(initialState);
  }, [setState]);

  return {
    loadingLabel: state.loadingLabel,
    isBuilding: state.isBuilding,
    setThinking,
    handleLoadingStateEvent,
    clearLoadingLabel,
    setBuilding,
    resetToIdle,
  };
};
